module.exports = __webpack_public_path__ + "assets/jian.5c5c644745c2ddaf5909e5fbbebce704.png";